import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";
import { ToastContainer, Slide, Zoom, Flip, Bounce } from "react-toastify";
import { Provider } from 'react-redux';
import { store } from './components/store/StoreRedux';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import ReactGA from 'react-ga';
import RouteChangeTracker from './components/services/RouteChangeTracker'
// pick a date util library
import MomentUtils from '@date-io/moment';
import CacheBuster from './CacheBuster'
import packageJson from '../package.json';
global.appVersion = packageJson.version;
const App = () => {
  ReactGA.initialize(process.env.REACT_APP_GA_TRACKINGID);
  ////
  return (
    <CacheBuster>
    {({ loading, isLatestVersion, refreshCacheAndReload }) => {
      if (loading) return null;
      if (!loading && !isLatestVersion) {
        // You can decide how and when you want to force reload
        refreshCacheAndReload();
      }
      return(
    <div className="App">
            <Provider store={store}>
       
          
          
              <BrowserRouter>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <Routes />
                  <RouteChangeTracker />
                </MuiPickersUtilsProvider>
              </BrowserRouter>
          <ToastContainer transition={Zoom} />
             
              
        
            </Provider>
          
    </div>
      );
     }}
     </CacheBuster>
  );
};
export default App;
